"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirestoreDocPath = exports.toFirestore = exports.fromFirestore = exports.fromScheme = void 0;
const common_1 = require("@mods-dev/common");
function fromScheme(scheme, snapshot, defaults) {
    const data = { ...defaults };
    snapshot.forEach((doc) => {
        const key = doc.id;
        const value = doc.data().value;
        data[key] = fromFirestore(value, scheme[key]);
    });
    return data;
}
exports.fromScheme = fromScheme;
function fromFirestore(value, type) {
    switch (type) {
        case 'date':
            return value.toDate().toISOString();
        case 'string':
        case 'number':
        case 'array':
        case 'boolean':
        default:
            return value;
    }
}
exports.fromFirestore = fromFirestore;
function toFirestore(firestore, value, type) {
    switch (type) {
        case 'date':
            return firestore.Timestamp.fromDate(new Date(value));
        case 'array':
            return [...value];
        case 'number':
            return common_1.toNumber(value);
        case 'boolean':
            return Boolean(value);
        case 'string':
        default:
            return value;
    }
}
exports.toFirestore = toFirestore;
function getFirestoreDocPath(path) {
    // https://firebase.google.com/docs/firestore/quotas#collections_documents_and_fields
    const escapeSeq = '####';
    if (path.includes(escapeSeq)) {
        throw new Error(`Firestore doc path can't include the string "${escapeSeq}"`);
    }
    // Must be valid UTF-8 characters
    path = Buffer.from(path, 'utf-8').toString();
    // Must be no longer than 1,500 bytes
    if (path.length * 4 > 1500) {
        throw new Error("Firestore doc path can't be longer than 1500 bytes");
    }
    // Cannot contain a forward slash (/)
    path = path.replace('/', escapeSeq);
    // Cannot solely consist of a single period (.) or double periods (..)
    if (path === '.' || path === '..') {
        path = path.replace('.', `${escapeSeq}.`);
    }
    // Cannot match the regular expression __.*__
    if (path.match(/__.*__/) !== null) {
        path = path.replace('__', `${escapeSeq}__`);
    }
    return path;
}
exports.getFirestoreDocPath = getFirestoreDocPath;
//# sourceMappingURL=utils.js.map